import React from 'react';
import './Hero.css';

const BOOK_CALL_QUERY = `Hi CampusXL, I would like to know more about the programs you offer. Shall I get a call from you side?\nThanks.`;

const Hero = ({ onApplyNow }) => {
  return (
    <section id="home" className="section hero-section">
      <div className="hero-content">
        <p className="hero-eyebrow">Transforming Education Through Industry Integration</p>
        <h1 className="hero-title">
          Find the right college
          <span className="hero-highlight">with expert counselling</span>
        </h1>
        <p className="hero-subtitle">
          CampusXL are committed to transforming higher education by building strong partnerships with universities and creating industry-relevant academic programs for the next generation of learners.
        </p>
        <div className="hero-actions">
          {/* <button className="primary-button">Explore Courses</button> */}
          <button
            className="secondary-button"
            onClick={() => onApplyNow(BOOK_CALL_QUERY)}
          >
            Book Free Call
          </button>
        </div>
        <div className="hero-meta">
          <span>Trusted educational partners</span>
          <span className="dot" />
          <span>Admissions open 2026-27</span>
        </div>
      </div>
      <div className="hero-visual">
        <div className="hero-card">
          <div className="hero-badge">Engineering • Management • More</div>
          <div className="hero-card-main">
            <h2>Start with your interests</h2>
            <p>
              Tell us what you enjoy and we will match you with colleges,
              courses and exams that fit.
            </p>
            <ul className="hero-list">
              <li>Personalised shortlists</li>
              <li>Guidance on exams & deadlines</li>
              <li>Support from first query to admission</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

